import {BffTrimData} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {parseTrimSelectId} from './format-trim-select-id';

export function findTrim<T>(
  trims: BffTrimData<T>[],
  modelTypeId: string
): BffTrimData<T> | undefined {
  const {carlineId, salesgroupId, trimId} = parseTrimSelectId(modelTypeId);

  return trims.find(
    (trim) =>
      trim.carlineId === carlineId &&
      trim.salesgroupId === salesgroupId &&
      trim.trimId === trimId
  );
}

export function getSelectedTrim<T>(
  trims: BffTrimData<T>[],
  modelTypeId: string
): BffTrimData<T> {
  const selectedTrim = findTrim<T>(trims, modelTypeId);

  if (!selectedTrim) {
    throw new Error('Invalid form state: Trim not found');
  }

  return selectedTrim;
}
